module.exports = __webpack_public_path__ + "static/img/6_2_1.6e4ba441.jpg";